import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

type StatusBadgeProps = {
  status: string;
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  switch (status) {
    case 'linked':
      return <LinkedText>Linked</LinkedText>;
    case 'pending':
      return <PendingBadge>Pending</PendingBadge>;
    case 'unlinked':
      return <UnlinkedText>Unlinked</UnlinkedText>;
    default:
      return <span>{status}</span>;
  }
}

const LinkedText = styled.span`
  color: ${colors.black};
`;

const PendingBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: ${colors.accentYellow};
  color: ${colors.black};
  font-size: 12px;
  font-weight: 700;
`;

const UnlinkedText = styled.span`
  color: ${colors.accentRed};
`;
